import React from "react";
import "./Scroll.css";

const Scroll = () => {
  return <div className="scroll"></div>;
};

export default Scroll;
